import React, { act, useEffect, useState } from "react";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, onValue } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

export default function App() {
  let [activeUser, setActiveUser] = useState(null);
  let [activeUserName, setActiveUserName] = useState([]);

  // multi
  const firebaseConfig = {
    apiKey: "AIzaSyBD9QAogmef5vWG1hqNGgKqUDMip-QHRtU",
    authDomain: "multiclicker-6a3c9.firebaseapp.com",
    databaseURL: "https://multiclicker-6a3c9-default-rtdb.firebaseio.com",
    projectId: "multiclicker-6a3c9",
    storageBucket: "multiclicker-6a3c9.firebasestorage.app",
    messagingSenderId: "788043626099",
    appId: "1:788043626099:web:0ef51c22bb2ef5aedddc06",
    measurementId: "G-0K19XGHLZY",
  };
// status
  // const firebaseConfig = {
  //   apiKey: "AIzaSyCqoQXWG11TJ2ZlWuHCise7tZ2SkoJr-kY",
  //   authDomain: "personal-2e64f.firebaseapp.com",
  //   databaseURL: "https://personal-2e64f-default-rtdb.firebaseio.com",
  //   projectId: "personal-2e64f",
  //   storageBucket: "personal-2e64f.firebasestorage.app",
  //   messagingSenderId: "258888089138",
  //   appId: "1:258888089138:web:58d8785a628c6acf5c062b",
  //   measurementId: "G-261T35PTXN",
  // };
  // redtwo
  // const firebaseConfig = {
  //   apiKey: "AIzaSyDfYRuzsZ5juXBEKyQqoqULpxzjQfdRo28",
  //   authDomain: "spyredtwo.firebaseapp.com",
  //   databaseURL: "https://spyredtwo-default-rtdb.firebaseio.com",
  //   projectId: "spyredtwo",
  //   storageBucket: "spyredtwo.firebasestorage.app",
  //   messagingSenderId: "950975986873",
  //   appId: "1:950975986873:web:c4fd6136ebf80cf74daf68",
  //   measurementId: "G-SSMMTVGBY4"
  // };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const db = getDatabase(app);

  let lastUpdated = Date.now();
  try {
    const activeSession = ref(db, "activeSession/");
    onValue(activeSession, (snapshot) => {
      const data = snapshot.val();
      if (Date.now() - lastUpdated > 900) {

        setActiveUser(data);
        setActiveUserName(Object.keys(data));
      }
    });
  } catch (error) {
    console.log("error hai");
  }

  return (
    <React.Fragment>
      <div className="row">
        {activeUserName.map((item) => {
          return (
            <div className="col-6 col-md-2 border" style={{ padding: 20,height:300 }} address={item}>
              <div className="heading text-center">
                <h6>{item}</h6>
                <span style={{ fontSize: 14 }}>Last updated at {new Date(activeUser[item].lastupdated).toString()}</span>
              </div>
              <div>
                <div>
                  <h6>Bal : {activeUser[item].bal}</h6>
                </div>
                <div>
                  <h6>Exp : {activeUser[item].exp}</h6>
                </div>
              </div>
              <div>
                <h6>Url :</h6>
                <span style={{wordWrap:'break-word'}}>{activeUser[item].url}</span>
              </div>
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
}
